import PricingFactorChangeInfo from './PricingFactorChangeInfo';

export default PricingFactorChangeInfo;
